import { useState } from "react";
import { Mail } from "lucide-react";
import NotifyMeModal from "@/components/NotifyMeModal";
import { trackCta } from "@/lib/analytics";

/**
 * Thin "Notify me" button that opens the shared NotifyMeModal.
 * Used inside section placeholders (Journal, Cards, Insights, Books)
 * so visitors can be quietly informed when that section opens.
 *
 * Props:
 *   store:  "apple" | "google" | "both"
 *   source: analytics tag (e.g. "placeholder_journal")
 *   label:  visible button text
 *   testid: data-testid for the button
 */
export default function NotifyButton({ store = "both", source, label, testid }) {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    trackCta(source || "notify_open", { placement: "section_placeholder" });
    setOpen(true);
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        data-testid={testid}
        className="inline-flex items-center gap-2 px-6 py-3 border border-gold/50 hover:border-gold bg-transparent hover:bg-gold/[0.06] text-[12px] tracking-[0.22em] uppercase text-bone hover:text-gold transition-all duration-300"
      >
        <Mail size={14} strokeWidth={1.5} />
        {label}
      </button>
      <NotifyMeModal open={open} source={store} onClose={() => setOpen(false)} />
    </>
  );
}
